<template>
	<div id="map-popup" style="height: 300px"></div>
</template>

<script>
import {MapFeatures} from "@/plugins/mapFeatures";

export default {
	props: {
		name: {
			type: String,
			required: true,
			default: "themap",
		},
		data: {
			type: Object,
			default: () => {},
		},
		zoom: {
			type: String,
			required: false,
			default: "12",
		},
		theme: {
			type: String,
			required: false,
			default: null,
		},
		streetview: {
			type: String,
			required: false,
			default: "false",
		},
		calledFrom: {
			type: String,
			requeride: false,
			default: "maps",
		},
	},
	data() {
		return {
			map: "",
			marker: null,
			mapFeature: null,
		};
	},
	methods: {
		showPositionMarker() {
			const position = {cy: this.data.latitude, cx: this.data.longitude};
			let content = this.generateInfowindowContentJob(this.data);
			this.marker = this.mapFeature.addMarkerToMap(position, {
				draggable: false,
				infoWindow: {
					content,
				},
			});
			this.$emit("getInstanceMapEmit", {map: this.map, marker: this.marker});
		},
		error(err) {
			this.map.setCenter({lat: 4.686699, lng: -74.0837187});
			console.warn("ERROR(" + err.code + "): " + err.message);
		},
		async initMap() {
			this.map = await new google.maps.Map(document.getElementById("map-popup"), {
				center: {lat: this.data.latitude, lng: this.data.longitude},
				zoom: 8,
			});
			this.mapFeature = new MapFeatures(this.map);
			this.showPositionMarker();
		},
		generateInfowindowContentJob(infoWindowData) {
			// Diseño del contenido html del infowindows
			let $docFragment = document.createDocumentFragment();
			let $infowindowDivContent = document.createElement("div");
			$infowindowDivContent.style.cssText = "text-align: justify";
			let $headerInfoWindowContent = document.createElement("div");
			$headerInfoWindowContent.className = "flex items-center justify-between";
			let $closeButton = document.createElement("button");
			$closeButton.textContent = "X";
			$closeButton.className = "bg-warning text-white rounded-full p-1 ml-2 cursor-pointer font-bold";
			$closeButton.addEventListener("click", () => {
				this.marker.infoWindow.close();
			});
			let $title = document.createElement("h5");
			$title.textContent = `${this.$t("VisitPoint")}`;
			let $subtitle = document.createElement("p");
			$subtitle.innerHTML = `<strong>${this.$t("Identification")}</strong>: ${
				infoWindowData.identification == null ? "-" : infoWindowData.identification
			} `;
			let $position = document.createElement("p");
			$position.innerHTML = `<strong>${this.$t("CurrentPosition")}</strong>: ${
				infoWindowData.latitude + ", " + infoWindowData.longitude
			} `;
			$position.className = "mt-1 mb-1";
			let $timeService = document.createElement("p");
			$timeService.innerHTML = `<strong>${this.$t("Routing.Table.TimeService")}</strong>: ${
				infoWindowData.time_service ? infoWindowData.time_service : "00:00:00"
			}`;
			$docFragment.appendChild($subtitle);
			$docFragment.appendChild($position);
			$docFragment.appendChild($timeService);
			$headerInfoWindowContent.appendChild($title);
			$headerInfoWindowContent.appendChild($closeButton);
			$infowindowDivContent.appendChild($headerInfoWindowContent);
			$infowindowDivContent.appendChild($docFragment);
			return $infowindowDivContent;
		},
	},
	mounted() {
		this.initMap();
	},
};
</script>

<style scoped>
/** custom content for map */
.map-custom-container {
	margin-top: calc(100% - 102%);
	margin-left: -35px;
	margin-right: -35px;
	height: 88vh;
}

.street-vien-container {
	width: 100%;
	height: 40vh;
}

.customizer-btn-map-opc {
	position: fixed;
	top: 50%;
	right: 0;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	z-index: 50000;
}

.customizer-btn-map-clear {
	position: fixed;
	top: 45%;
	right: 0;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	z-index: 50000;
}

.map-top-left-possition {
	position: fixed;
	top: 69px;
	left: 100px;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	z-index: 50000;
}

.map-custom-container-calendar {
	height: 560px !important;
}

@media (min-width: 1400px) {
	.map-custom-container {
		margin-top: calc(100% - 102%);
		height: 93vh;
	}

	.street-vien-container {
		width: 100%;
		height: 60vh;
	}
}

@media (max-width: 992px) {
	.map-custom-container {
		margin-top: calc(100% - 109%);
		height: 89vh;
	}

	.street-vien-container {
		width: 100%;
		height: 40vh;
	}

	.map-top-left-possition {
		position: fixed;
		top: 69px;
		left: 10px;
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
		z-index: 50000;
	}
}
</style>
